import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { __API_URL__ } from "../SERVER_URL";

const useForwardSupportConversationMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ conversationId, userIds }) => {
      const token = localStorage.getItem("token");
      const { data } = await axios.post(
        `${__API_URL__}/api/support/admin/conversations/${conversationId}/forward/`,
        { user_ids: userIds },
        { headers: { Authorization: `Token ${token}` } }
      );
      return data;
    },
    onSuccess: (_, { conversationId }) => {
      queryClient.invalidateQueries({ queryKey: ["support_conversation_detail", conversationId] });
      queryClient.invalidateQueries({ queryKey: ["support_forward_candidates", conversationId] });
      queryClient.invalidateQueries({ queryKey: ["support_conversations"] });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.detail || "Failed to forward conversation.");
    },
  });
};

export default useForwardSupportConversationMutation;
